import { GetComputersParams } from 'mbs-ui-shared@models/Computer';
import { ComputersStatisticModel } from 'mbs-ui-shared@models/computersStatistic';
import { createAction, props } from '@ngrx/store';
import { StoreTypes } from '../storeTypes.enum';

export const loadStatistic = createAction(
  `[${StoreTypes.ComputersStatistic}] Load Statistic`,
  props<{ filters: GetComputersParams; force?: boolean; silent?: boolean }>()
);
export const loadStatisticSuccess = createAction(
  `[${StoreTypes.ComputersStatistic}] Load Statistic Success`,
  props<{ data: ComputersStatisticModel }>()
);
export const loadStatisticError = createAction(`[${StoreTypes.ComputersStatistic}] Load Statistic Error`);

export const clear = createAction(`[${StoreTypes.ComputersStatistic}] Clear Data`);

export const checkOneComputerExist = createAction(
  `[${StoreTypes.ComputersStatistic}] Check One Computer Exist`,
  props<{ force?: boolean }>()
);
export const checkOneComputerSuccess = createAction(
  `[${StoreTypes.ComputersStatistic}] Check One Computer Exist Success`,
  props<{ data: boolean }>()
);
export const checkOneComputerError = createAction(`[${StoreTypes.ComputersStatistic}] Check One Computer Exist Error`);
